import _ from 'lodash';

export const formatMutationTemplate = ({
  updateIncludeReport,
  morphologyTemplate,
}: {
  updateIncludeReport: any[];
  morphologyTemplate: any[];
}) => {
  const selectedTemplates: any[] = [];
  const deSelectedTemplates: any[] = [];

  const reviewedTemplates: any[] = [];
  const unReviewedTemplates: any[] = [];

  _.forEach(morphologyTemplate, (x) => {
    const findUpdateInclude = _.find(updateIncludeReport, (item) => item.id === x.id);
    if (findUpdateInclude) {
      if (findUpdateInclude.isIncludedToReport) {
        selectedTemplates.push(x.id);
      } else {
        deSelectedTemplates.push(x.id);
      }
    } else if (x.isIncludedToReport) {
      selectedTemplates.push(x.id);
    } else {
      deSelectedTemplates.push(x.id);
    }
  });
  return {
    selectedTemplates,
    deSelectedTemplates,
    reviewedTemplates,
    unReviewedTemplates,
  };
};

export default formatMutationTemplate;
